import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Video20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M6 13C6 13.5523 5.55228 14 5 14C4.44772 14 4 13.5523 4 13C4 12.4477 4.44772 12 5 12C5.55228 12 6 12.4477 6 13Z'
      fill='currentColor'
    />
    <path
      d='M10 13C10 13.5523 9.55228 14 9 14C8.44771 14 8 13.5523 8 13C8 12.4477 8.44771 12 9 12C9.55228 12 10 12.4477 10 13Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.5 2.25C0.809645 2.25 0.25 2.80964 0.25 3.5V16.5C0.25 17.1904 0.809645 17.75 1.5 17.75H12.5C13.1904 17.75 13.75 17.1904 13.75 16.5V13.9606L18.1968 15.0723C18.9858 15.2695 19.75 14.6728 19.75 13.8596V6.14039C19.75 5.32717 18.9858 4.73047 18.1968 4.92771L13.75 6.03942V3.5C13.75 2.80964 13.1904 2.25 12.5 2.25H1.5ZM13.75 7.58558V12.4144L18.25 13.5394V6.46058L13.75 7.58558ZM1.75 16.25V3.75H12.25V16.25H1.75Z'
      fill='currentColor'
    />
  </Svg>
);

Video20.displayName = 'Video20';
export default Video20;
